export const TRADING_HISTORY_API = 'https://histdatafeed.vps.com.vn/tradingview/history'
export const TRADING_REALTIME_URL = 'https://tradingviewrealtime.vps.com.vn'
export const VIETCAP_VALUATION_API = 'https://iq.vietcap.com.vn/api/iq-insight-service/v1/valuation'
export const VIETCAP_VALUATION_PARAMS = { reportType: 'DAILY', lengthReport: 5 }
